export const locale = {
  lang: 'zh2',
  data: {
    'TEMPLATE':{
      'PANT_TEMPLATE':{
        'INST_1':'下载问题模板',
         'INST_2':'对模板进行必要的更改',
         'INST_3':'加载问题模板',
         'BTN_DESC_PLAN':'问题模板',
         'BUSC_PLAN_TEX':'单击此处搜索模板问题',
         'TEMP_CARG_TIT':'模板信息',
         'TOT_PREG':'总问题数',
         'TOT_PREG_MODI':'已修改的问题总数',
         'TOT_PREG_NUE':'新问题总数',
         'TEMP_CARG_TIT_CAR':'已加载模板信息',
         'COMPL_PAS_SIN_MODI':'您尚未进行任何修改。 您一定要完成此步骤?',
         'SUCC_CAR_PLAN':'模板已成功加载。 请完成此步骤',
         'COMPLE_PASO_CON_MODI':'您确定要完成当前输入的更改吗？',
         'NO_MODIF':'不要修改此单元格内容',
         'ERROR_CARGA':'无法上载文件，在一个或多个限制的单元格中检测到修改，请再次下载模板并进行所需的修改，而无需修改限制的单元格。\n\n受限单元格包含注释，指示不应修改其内容',
         'FORALL_EXCEDIDAS': '检测到加载的模板中存在的4All实践数量超过了允许的实践数量，仅加载了与允许的最大数量相对应的实践 ',
         'OPCIONDEMOGRAFICOS': '此单元格必须包含人口统计目录表中未更改的值',
         'CARGANDO_PREGUNTAS': '从模板加载问题'
      },
      'CATALOGO_IDIOMAS':{
        'z1': '简体中文',
        'z2': '繁体中文',
        'ko': '韩国人',
        'ja': '日本人',
        'pt': '葡萄牙语',
        'en': '英语',
        'fr': '法语',
        'de': '德语',
        'it': '意大利语',
        'es': '西班牙语',
        'tr': '土耳其',
        'ms': '马来语',
        'ro': '罗马尼亚语',
        'vi': '越南语',
        'bg': '保加利亚语',
        'hi': '印地语',
        'ru': '俄语',
        'mn': '蒙',
        'nl': '荷兰语',
        'ar': '阿拉伯',
        'ua': '乌克兰',
        'id': '印度尼西亚',
      },
      'HOJAS_EXCEL':{
       'Instrucciones': '使用说明',
       'Catalogo':'目录',
       'Detalles': '细节',
       'CatDemograficos': '人口目录',
       'Nps':'Nps',
       'Reactivos':'声明',
       'Control':'控制',
       'Demograficos':'受众特征',
       'Abiertas':'打开',
       'Forall':'对全部',
       'Adicionales':'额外',
     },
     'COLUMNAS_H_CATA':{
       'ClaveIdiomas':'语言科',
       'NombreIdiomas':'语言名称',
       'IDTipoPregunta':'问题类型ID',
        'TiposPreguntas':'问题类型',
        'ClaveTipoElemento':'元素类型键',
        'TiposElementos':'元素类型',
       'CONTEM_TIP_PREG':{
        '1':'NPS /控制/附加问题（多项选择，一个答案）',
        '2_1':'NPS /控制/开放式问题,开放文本类型',
        '2_2':'NPS /控件/开放式问题,数字文本类型',
        '3':'反应类型问题',
        '4':'人口类型问题（多项选择,一个答案）',
        '5':'练习4全部',
        '6':'其他问题（多项选择,多项答案）',
       },
       'CONTEM_TIP_SEGM':{
       'question':'问题文本',
        'answer_1':'答案1的文字',
        'answer_2':'答案2的文字',
        'answer_n':'答案n的文字',
        'practice':'实践文本4All',
        'description':'实践4All的描述文字',
        'statement_1':'练习4All的问题1',
        'statement_2':'练习4All的问题2',
       }
     },
     'COLUMNAS_SECCION':{
      'Id':	'Id',
      'TipoDePregunta':	'QuestionType',
      'PalabrasClave':	'KeyWords',
      'NuevaPregunta':	'NewQuestion',
      'Eliminable':	'Eliminable',
      'Editable':	'Editable',
      'RespuestaObligatoria':	'CompulsoryAnswer',
      'MostrarPregunta':	'ShowQuestion',
      'Dimension':	'Dimension',
      'Competencia':	'Competence',
      'Subcompetencia':	'Subcompetence',
      'TipoDemografico':	'TypeDemographic',
      'practice':	'practice',
      'description':	'description',
      'statement_1':	'statement_1',
      'statement_2':	'statement_2',
      'question':	'question',
      'answer':	'answer',
      'OpcionOtro': '回答类型“其他”'

     }
    }
  }
};
